import { RcFile } from 'antd/lib/upload';

export function readFile(file: RcFile): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsText(file);

        reader.onload = e => {
            const content = e?.target?.result as string;
            resolve(content);
        };

        reader.onerror = err => {
            console.error(err);
            reject();
        };
    });
}
